import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'amount'})
@Injectable({providedIn: 'root'})
export class AmountConversionPipe implements PipeTransform {

    transform(pAmount: number): string {
        if (pAmount) {
            return pAmount.toLocaleString('en-IN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        } else if (pAmount == 0) {
            return '0.00';
        } else if (pAmount == null) {
            return '0.00';
        }
    }
}